import * as React from 'react';
import ReactDOM from 'react-dom';
import * as mobx from 'mobx';
import * as IoC from 'typescript-ioc';
import { RouterProvider } from 'react-router5';
import { RawIntlProvider } from 'react-intl';
import { GlobalContext } from './components/global.context';
import { GlobalViewModel } from './components/global.viewmodel';
import { IRouter } from './infrastructure/router';
import { RouteParams, Routes } from './routes-table';
import { Router } from './infrastructure/implementations/router';
import { Layout } from './components/layout';
import './ioc-configuration';

import { EN_US } from './constants/locales.constants';
import { IReactIntlProvider } from './infrastructure/react-intl-provider';

// make sure state transitions does not happens outside of actions
mobx.configure({enforceActions: 'observed'});

// init router with static routes table
const router = IoC.Container.get<IRouter<RouteParams>>(IRouter);
router.initialize(Routes);

// init global view model (aka application state)
const globalViewModel = IoC.Container.get<GlobalViewModel>(GlobalViewModel);

// start router
router.start();

// during the application bootstrap we explicitly rely on particular implementation of router service
// it's not fancy but it is ok as bootstrapping is a part of infrastructure setup
// @ts-ignore
const router5Instance = (router as Router<RouteParams>).router;


/* Initializing IntlProvider */
const CURRENT_LOCALE = EN_US;
const reactIntlProvider = IoC.Container.get<IReactIntlProvider>(IReactIntlProvider);
reactIntlProvider.initialize(CURRENT_LOCALE);

ReactDOM.render(
    <React.StrictMode>
        <RawIntlProvider value={reactIntlProvider.getIntl()}>
            <RouterProvider router={router5Instance}>
                <GlobalContext.Provider value={globalViewModel}>
                    <Layout />
                </GlobalContext.Provider>
            </RouterProvider>
        </RawIntlProvider>
    </React.StrictMode>,
    document.getElementById('oe-connect-root')
);
